/**
 * @generated SignedSource<<6cae5891442e9ac5b9bdabdb41aa6cc0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_AssignQuoteRuleMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type productSidePanelContent_AssignQuoteRuleMutation$data = {
  readonly assignProductsToQuoteRule: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_AssignQuoteRuleMutation = {
  response: productSidePanelContent_AssignQuoteRuleMutation$data;
  variables: productSidePanelContent_AssignQuoteRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToQuoteRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_AssignQuoteRuleMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_AssignQuoteRuleMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "78a41e564ab5df4e0a4b90fb402ba83f",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_AssignQuoteRuleMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_AssignQuoteRuleMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToQuoteRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "c31ba27c742b42e9e7ec4ca284805b4c";

export default node;
